import React from 'react'
import { CFooter } from '@coreui/react'

const AppFooter = () => {
  return (
    <CFooter>
      <div>
        <span className="ms-1">&copy; {new Date().getFullYear()} Ethoventures.&nbsp;All right reserved.</span>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
